export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          id="background"
          fill="none"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M0 0H512V512H0z"
        ></path>
        <path
        id="logo"
          fill="currentColor"
          d="M286.968 456V273.538h61.244l9.17-71.103h-70.413V157.04c0-20.588 5.72-34.62 35.235-34.62l37.656-.01V58.807C353.35 57.934 331.003 56 304.992 56c-54.288 0-91.45 33.146-91.45 93.998v52.437H152.14v71.103h61.4V456h73.428z"
        ></path>
      </g>
    </svg>
  );
}